import { HttpService } from "@/core";
import { ExportResp } from "@/core/interface";
import { MaterialDetailResp, MaterialImportResp, MaterialReq } from "./material-table.interface";

export class MaterialTableService {
  static useMaterialCreateApi() {
    const api = (contractId: string, data: MaterialReq) =>
      HttpService.axios({
        method: "POST",
        url: `/contract/${contractId}/material`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useMaterialDetailApi() {
    const api = ({ contractId, name }) =>
      HttpService.axios({
        method: "GET",
        url: `/contract/${contractId}/material`,
        params: { name },
      });
    return HttpService.useRequest<MaterialDetailResp>(api);
  }
// 施工预算
  static ConstructionBudgetApi() {
    const api = ({ contractId, name }) =>
      HttpService.axios({
        method: "GET",
        url: `/contract/construction/${contractId}/material`,
        params: { name },
      });
    return HttpService.useRequest<MaterialDetailResp>(api);
  }

  static useMaterialImportApi() {
    // const api = (contractId: string, url: string) =>
    const api = (url: string) =>
      HttpService.axios({
        method: "POST",
        url: `/contract/excel/materialListAnalysis`,
        // url: `/contract/${contractId}/import/material`,
        data: { url },
      });
    return HttpService.useRequest<MaterialImportResp>(api);
  }

  static useMaterialExportApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/contract/${id}/export/material`,
      });
    return HttpService.useRequest<ExportResp>(api, { isOutError: true });
  }
}
